module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("3fPCe"))).then(() => parcelRequire('8rm4T'));